import "./SellYourLand.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartYourProject from "./sections/StartYourProject";
import StructuralFooter from "@/reusable_sections/Footer";
export default function SellYourLandPage() {
  return <div>
      <MainNavigation />
      <StartYourProject />
      <StructuralFooter />
    </div>;
}